// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{min-height:100%}.footer{text-align:center;bottom:0;width:100%;height:100px;background-color:#f8f9fa;font-size:12px;box-shadow:0 2px 5px 0 hsla(0,0%,63.1%,.5)}.footer .social{margin-top:15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
